import actions from 'src/modules/absence/importer/absenceImporterActions';
import importerReducers from 'src/modules/shared/importer/importerReducers';

export default importerReducers(actions);
